/**
 * Generates a stable ID for a chat message from its content and timestamp.
 */
export const makeMessageId = (text: string, ts: Date): string =>
    `${ts.getTime()}-${encodeURIComponent(text.slice(0, 32))}`;
